export default __webpack_public_path__ + "static/media/TB_Logo.65df163b.png";